import { Configuration } from '@/react/kubernetes/configs/types';

export function getSecret(
  secrets?: Configuration[],
  volumeConfigName?: string
) {
  return secrets?.find((secret) => secret.Name === volumeConfigName);
}
